/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Medic } from './Medic';
import {
    MedicFromJSON,
    MedicFromJSONTyped,
    MedicToJSON,
} from './Medic';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface MedicPagination
 */
export interface MedicPagination {
    /**
     * 
     * @type {Array<Medic>}
     * @memberof MedicPagination
     */
    data?: Array<Medic>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof MedicPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the MedicPagination interface.
 */
export function instanceOfMedicPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MedicPaginationFromJSON(json: any): MedicPagination {
    return MedicPaginationFromJSONTyped(json, false);
}

export function MedicPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(MedicFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function MedicPaginationToJSON(value?: MedicPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(MedicToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

